const digest = '0bdabbf28a79f93e34152619c87bef66653908130a9016a43dd1b7412a133778';
const css = `._banner_1qbsf_1{bottom:0;width:100%}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'banner': '_banner_1qbsf_1' };
export const banner = '_banner_1qbsf_1';
export { css, digest };